import { IDefaultError } from './error';

interface IApiErrorOptions {
  status?: number;
  url?: string;
  method?: string;
  fallbackMessage?: string;
}

// Real `Error` wrapper around a failed request, so an uncaught rejection still
// carries a stack trace, name and message into Bugsnag instead of a bare object
// (`extractErrorMessage`/`extractErrorCode` keep working via the `data` shape).
class ApiError extends Error {
  data: IDefaultError['data'];

  status?: number;

  url?: string;

  method?: string;

  constructor(data: IDefaultError['data'] | undefined, options: IApiErrorOptions = {}) {
    super(data?.message || data?.error || options.fallbackMessage || 'Request failed');

    this.name = 'ApiError';
    this.data = data || {};
    this.status = options.status;
    this.url = options.url;
    this.method = options.method;
  }
}

export default ApiError;
